import { applyMiddleware, compose, createStore } from 'redux';
import { types } from 'redux-act';
import thunkMiddleware from 'redux-thunk';

import config from 'config';

import reducer from './reducers';

const isNotProduction = config.get('client.env') !== 'production';

function getEnhancers() {
    // @ts-ignore
    const isBrowserWithExtension = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const isDevToolsEnabled = config.get('client.isDevToolsEnabled');

    if (isNotProduction && isDevToolsEnabled && isBrowserWithExtension) {
        // @ts-ignore
        return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            trace: true,
            traceLimit: 25
        });
    }

    return compose();
}

export function makeStore(initialStore) {
    /* Добавляем Redux DevTools не на проде */
    const composeEnhancers = getEnhancers();

    /* Библиотека redux-act выдает ошибки при hot reload, выключаем проверку типов не на проде */
    if (isNotProduction) {
        types.disableChecking();
    }

    const store = createStore(reducer, initialStore, composeEnhancers(applyMiddleware(thunkMiddleware)));

    // @ts-ignore
    if (module.hot) {
        // @ts-ignore
        module.hot.accept('./reducers', () => {
            // eslint-disable-next-line global-require
            const createNextReducer = require('./reducers').default;

            store.replaceReducer(createNextReducer);
        });
    }

    return store;
}
